<template>
  <div class="service">
    <Header />
    <div class="introduction">
      <div class="content content__box">
        <div class="left">
          <div class="title">业务中台</div>
          <div class="title__tips">从整体战略、业务支撑、连接消费者和业务创新等方面进行统筹规划，将业务逻辑进行抽象包装整合，实现后端业务资源到前台易用能力的转化</div>
          <div class="btn__box">
            <span class="btn-detail" @click="linkTo('/register')">免 费 试 用</span>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div id="navagation" class="navagation">
      <div class="content content__box" :class="{ isFixed: isFixed }">
        <div class="nav__item">
          <a href="#Cfunction">产品功能</a>
        </div>
        <div class="nav__item">
          <a href="#Cadvantage">产品优势</a>
        </div>
        <!-- <div class="nav__item"><a href="#Cscene">应用场景</a></div> -->
      </div>
    </div>
    <div id="Cfunction"></div>
    <div class="product">
      <div class="content content__box">
        <div class="product__title">产品功能</div>
        <div class="product__detail">
          <div class="left"></div>
          <div class="right">
            <div class="title">整合业务服务</div>
            <div class="title__tips">整合每个业务所需的服务，向应用开放接口获取业务的管理要求，将频繁变化的业务逻辑包装统一到业务中台</div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">会员中心-管理会员的业务服务</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">营销中心-管理营销的业务服务</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">商品中心-管理商品的业务服务</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">订单中心-管理交易的业务服务</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">任务中心-管理任务的业务服务</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">店务中心-管理门店层面的业务服务</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Cadvantage"></div>
    <div class="advantage">
      <div class="content content__box">
        <div class="advantage__title">产品优势</div>
        <div class="advantage__detail">
          <div class="advantage__item">
            <div class="item__icon item__icon01"></div>
            <div class="item__title">安全稳定</div>
            <div class="item__tips">将业务逻辑封装打包在中台中，十分安全和稳定</div>
          </div>
          <div class="advantage__item">
            <div class="item__icon item__icon02"></div>
            <div class="item__title">易迭代</div>
            <div class="item__tips">针对频繁变化的需求，在平台上对接口进行更改，对比更改应用上的功能，平台则更容易迭代更新</div>
          </div>
          <div class="advantage__item">
            <div class="item__icon item__icon03"></div>
            <div class="item__title">易扩展</div>
            <div class="item__tips">支持不同系统的对接，提供对接的开发支撑，对比传统中台，业务中台则更容易扩展</div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "service",
  components: { Header, Footer },
  data() {
    return {
      isFixed: false,
      offsetTop: 442
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.watchScroll);
      this.offsetTop = document.querySelector("#navagation").offsetTop;
    });
  },
  methods: {
    watchScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
    linkTo(url) {
      this.$router.push({
        path: url
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  user-select: none;
}
.introduction {
  padding-top: 59px;
  padding-bottom: 58px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 100%;
  background-image: url("../../../assets/img/service/public/2290@2x.png");
  .content__box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .left {
      width: 612px;
      text-align: left;
      margin-right: 158px;
      .title {
        padding-top: 53px;
        font-size: 44px;
        font-weight: bold;
        line-height: 62px;
        color: rgba(255, 255, 255, 1);
      }
      .title__tips {
        width: 612px;
        padding-top: 24px;
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        color: rgba(255, 255, 255, 1);
      }
      .btn__box {
        padding-top: 48px;
        .btn-detail {
          display: inline-block;
          text-align: center;
          width: 140px;
          height: 38px;
          border-radius: 19px;
          font-size: 14px;
          font-weight: 400;
          line-height: 38px;
          color: rgba(62, 113, 255, 1);
          border: 1px solid #3e71ff;
          cursor: pointer;
        }
        .btn-detail:hover {
          background: rgba(62, 113, 255, 1);
          box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
          color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(62, 113, 255, 0.2);
        }
      }
    }
    .right {
      width: 395px;
      height: 323px;
      background-repeat: no-repeat;
      background-position: top center;
      background-size: 100% 100%;
      background-image: url("../../../assets/img/service/indexBusiness/3@2x.png");
    }
  }
}
.navagation {
  background-color: #fff;
  .content__box {
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .nav__item {
      width: 260px;
      height: 62px;
      font-size: 16px;
      font-weight: 400;
      line-height: 62px;
      color: rgba(41, 43, 58, 1);
      cursor: pointer;
    }
  }
  .isFixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }
}
.product {
  background: rgba(248, 250, 253, 1);
  .content__box {
    .product__title {
      padding-top: 80px;
      padding-bottom: 40px;
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    .product__detail {
      padding: 49px 0 37px 98px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .left {
        width: 459px;
        height: 471px;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 100%;
        background-image: url("../../../assets/img/service/indexBusiness/2561@2x.png");
      }
      .right {
        width: 486px;
        margin-left: 156px;
        text-align: left;
        .title {
          padding-top: 30px;
          padding-bottom: 30px;
          font-size: 26px;
          font-weight: bold;
          line-height: 37px;
          color: rgba(41, 43, 58, 1);
        }
        .title__tips {
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
          padding-bottom: 20px;
        }
        .product__item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 44px;
          .item__icon {
            width: 21px;
            height: 21px;
            background-repeat: no-repeat;
            background-position: top center;
            background-size: 100% 100%;
            background-image: url("../../../assets/img/public/499@2x.png");
          }
          .item__name {
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            color: rgba(41, 43, 58, 1);
          }
        }
      }
    }
  }
}
.advantage {
  padding-bottom: 80px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
  background-image: url("../../../assets/img/service/public/2255@2x.png");
  .content__box {
    .advantage__title {
      padding-top: 80px;
      padding-bottom: 40px;
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    .advantage__detail {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      background: rgba(248, 250, 253, 1);
      .advantage__item {
        padding-top: 103px;
        width: 400px;
        padding-bottom: 60px;
        text-align: center;
        .item__icon {
          width: 100px;
          height: 100px;
          margin: 0 auto;
          background-repeat: no-repeat;
          background-position: top center;
          background-size: 100% 100%;
        }
        .item__icon01 {
          background-image: url("../../../assets/img/service/indexBusiness/2569@2x.png");
        }
        .item__icon02 {
          background-image: url("../../../assets/img/service/indexBusiness/2562@2x.png");
        }
        .item__icon03 {
          background-image: url("../../../assets/img/service/indexBusiness/2569@2x.png");
        }
        // .item__icon04 {
        //   // background-image: url("../../../assets/img/service/indexBusiness/2498@2x.png");
        // }
        .item__title {
          padding-top: 73px;
          font-size: 26px;
          font-weight: bold;
          line-height: 37px;
          color: rgba(41, 43, 58, 1);
          margin: 0 auto;
        }
        .item__tips {
          padding-top: 30px;
          width: 240px;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
          margin: 0 auto;
        }
      }
    }
  }
}
@keyframes play {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
